import { TuitionFeeClassSettings } from '@/plugins/api'

export default {
  namespaced: true,

  state: {
    items: [],
    total: 0,
    loading: false,
  },

  mutations: {
    SET_ITEMS(state, items) {
      state.items = items
    },
    SET_TOTAL(state, total) {
      state.total = total
    },
    SET_LOADING(state, loading) {
      state.loading = loading
    },
  },

  actions: {
    async fetchItems({ commit }, params) {
      try {
        commit('SET_LOADING', true)
        const result = await Promise.all([TuitionFeeClassSettings.fetch(params), TuitionFeeClassSettings.count(params)])
        commit('SET_ITEMS', result[0])
        commit('SET_TOTAL', result[1])
      } catch (error) {
        console.error(error)
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async fetchOne({ commit }, id) {
      try {
        commit('SET_LOADING', true)
        const { data } = await TuitionFeeClassSettings.fetchOne(id)
        return data
      } catch (error) {
        console.error(error)
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async create({ dispatch }, params) {
      try {
        await TuitionFeeClassSettings.create(params)
        dispatch('fetchItems')
      } catch (error) {
        console.error(error)
      }
    },

    async update({ dispatch }, { id, params }) {
      try {
        await TuitionFeeClassSettings.update(id, params)
        dispatch('fetchItems')
      } catch (error) {
        console.error(error)
      }
    },

    async remove({ dispatch }, id) {
      try {
        await TuitionFeeClassSettings.remove(id)
        dispatch('fetchItems')
      } catch (error) {
        console.error(error)
      }
    },
  },
}
